export default __webpack_public_path__ + "static/media/Realme_Two.64ca411c.png";